module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-VC-2-Article.7dae1d39.jpg";